import { LanguageSelect, LocaleFormat } from '@components'

import { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { selectableInvoiceLanguages } from '@features/invoices/constants/selectableInvoiceLanguages'
import { syncDefaultInvoiceTextsOnLanguageChange } from '@features/invoices/utils/syncDefaultInvoiceTextsOnLanguageChange'

import { useInvoiceEditorForm } from '../../../../../../../../../../../../contexts/invoiceEditorFormContext'

interface InvoiceLanguageProps {
  onLanguageChange: () => void
}

export const InvoiceLanguage = ({ onLanguageChange }: InvoiceLanguageProps): ReactElement => {
  const { t } = useTranslation()
  const { invoiceEditorForm, trackInvoiceEditor } = useInvoiceEditorForm()
  const { FormItem, getValues, setValue } = invoiceEditorForm

  const handleLanguageSelect = useCallback(
    (newLanguage?: LocaleFormat, previousLanguage?: LocaleFormat) => {
      syncDefaultInvoiceTextsOnLanguageChange({ getValues, setValue, t, newLanguage, previousLanguage })
      trackInvoiceEditor('Form - Language dropdown selected', { language: newLanguage })
      onLanguageChange()
    },
    [getValues, onLanguageChange, setValue, t, trackInvoiceEditor],
  )

  return (
    <FormItem
      name="language"
      render={({ field: { value, onChange, ...rest } }) => (
        <LanguageSelect
          {...rest}
          dropdownSize="m"
          languages={selectableInvoiceLanguages}
          onSelect={(newLanguage) => {
            onChange(newLanguage)
            handleLanguageSelect(newLanguage, value)
          }}
          selectedId={value}
          size="sm"
          withSearch={false}
        />
      )}
    />
  )
}
